import React from "react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { DailyStats } from "@/types/stats";

interface TrendChartProps {
  dailyBreakdown: DailyStats[];
}

export const TrendChart: React.FC<TrendChartProps> = ({ dailyBreakdown }) => {
  const data = dailyBreakdown.map((day) => ({
    date: new Date(day.date).toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
    }),
    success: day.success,
    failure: day.failure,
  }));

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <h3 className="mb-1 text-lg font-semibold text-slate-900 dark:text-white">
        Success vs Failure Trend
      </h3>
      <div className="min-h-[240px]">
        <ResponsiveContainer width="100%" height={240}>
          <LineChart data={data} margin={{ top: 8, right: 16, bottom: 8, left: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
            <XAxis dataKey="date" tick={{ fill: "#64748b", fontSize: 12 }} />
            <YAxis tick={{ fill: "#64748b", fontSize: 12 }} allowDecimals={false} />
            <Tooltip
              contentStyle={{
                background: "#ffffff",
                border: "1px solid #e2e8f0",
                borderRadius: "0.75rem",
              }}
              labelStyle={{ color: "#0f172a" }}
              itemStyle={{ color: "#0f172a" }}
            />
            <Legend />
            <Line
              type="monotone"
              dataKey="success"
              name="Success"
              stroke="#10b981"
              strokeWidth={2}
              dot={false}
              activeDot={{ r: 4 }}
            />
            <Line
              type="monotone"
              dataKey="failure"
              name="Failure"
              stroke="#ef4444"
              strokeWidth={2}
              dot={false}
              activeDot={{ r: 4 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
